import React from 'react';
import { t } from '../i18n';
import { GithubPicker } from 'react-color'
import {withRouter} from "react-router-dom";

import '../style/ColorPicker.scss'

class PaletteColorPicker extends React.Component {
  state = {
    displayColorPicker: false
  };

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker })
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false })
  };

  render() {
    // allowNone: adds an "Aucune couleur" choice (fully transparent), off by default so other editors are unchanged
    const { onChange, disableAlpha, palette, color, allowNone } = this.props;
    const isNone = !!color && /^rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*0(\.0+)?\s*\)$/.test(color);

    if(!palette) return null;

    const buttonContent = (hasColor) => {
      if(hasColor && isNone) {
          return <span className={'tsk-color tsk-color--none'} title={'Aucune couleur'} />
      }
      if(hasColor) {
          return <span className={'tsk-color'} style={{background: color}} />
      }

      return <span>{t('ui.pickcolor')}</span>
    } 
    return (
      <div className={'tsk-colorpicker-container'}>
        <button className={'tsk-colorpicker-block'} onClick={ this.handleClick }>
          {buttonContent(color)}
        </button>
        { this.state.displayColorPicker &&
          <div className={'tsk-colorpicker-popover'}>
            <div className={'.tsk-colorpicker-cover'} onClick={ this.handleClose }/>
            <GithubPicker color={ color || palette[0] } colors={palette} onChange={ (newValue) => {
              this.setState({ displayColorPicker: false });
              onChange(newValue);
            } } disableAlpha={disableAlpha} />
            { allowNone &&
              <button type="button" className={'tsk-colorpicker-none'} onClick={ () => {
                this.setState({ displayColorPicker: false });
                onChange({ rgb: { r: 0, g: 0, b: 0, a: 0 } });
              } }>{'Aucune couleur'}</button>
            }
          </div>
        }
      </div>
    )
  }
}

export default withRouter(PaletteColorPicker)